import React from 'react';

export const PCIIcon = () => {
  return (
    <div style={{ width: 300, height: 89 }}>
      <img style={{ width: 300, height: 89 }} src="/pictures/PCIIcon.png" alt="" />
    </div>
  );
};
